import Loadable from 'app/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const Template = Loadable(
  lazy(() => import('../pages/templateConfiguration/index'))
)

const templateConfigurationRoutes: RouteObject[] = [
  {
    path: '/template-configuration',
    element: <Template />,
  },
]

export default templateConfigurationRoutes
